/*
    Copyright 2020 Lauren Gyldenlove.
    This file is part of Duelmaster.

    Duelmaster is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    Duelmaster is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with Foobar.  If not, see <https://www.gnu.org/licenses/>.
 */

import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyle = makeStyles({
    licenseFrame: {
        width: "100%",
        color: "#fff",
        border: "1px solid #555",
        minHeight: "40vh"
    }
});

export const License = () => {
    const classes = useStyle();

    const [open, setOpen] = React.useState<boolean>(false);
    const handleClose = () => {
        setOpen(false);
    }

    return (
        <React.Fragment>
            Software licensed under the <a href="#license" onClick={() => setOpen(true)}>GNU Affero General Public License, V3</a>
            <Dialog open={open} fullWidth maxWidth={"lg"} scroll={'paper'} onClose={handleClose}>
                <DialogTitle>Software License</DialogTitle>
                <DialogContent>
                    <iframe className={classes.licenseFrame} title="GNU Affero General Public License" src="/LICENSE.html"></iframe>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={handleClose}>Close</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
